var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.type === "anchor"
    ? _c(
        "a",
        {
          staticClass: "button--container",
          class: _vm.containerClasses,
          style: _vm.containerStyles,
          attrs: { href: _vm.href },
          on: {
            mousedown: _vm.buttonMouseDownHandler,
            mouseup: _vm.buttonMouseUpHandler,
            mouseleave: _vm.mouseLeaveHandler,
            click: _vm.clickHandler,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "button--label",
              class: { "material-icons": _vm.icon },
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "button--ripple",
            on: { animationend: _vm.buttonRippleAnimationEndHandler },
          }),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      )
    : _c(
        "button",
        {
          staticClass: "button--container",
          class: _vm.containerClasses,
          style: _vm.containerStyles,
          attrs: { type: _vm.type },
          on: {
            mousedown: _vm.buttonMouseDownHandler,
            mouseup: _vm.buttonMouseUpHandler,
            mouseleave: _vm.mouseLeaveHandler,
            click: _vm.clickHandler,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "button--label",
              class: { "material-icons": _vm.icon },
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "button--ripple",
            on: { animationend: _vm.buttonRippleAnimationEndHandler },
          }),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }